import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import StatusProgressbar from '../AppetiteSummary/StatusProgressbar';
import fetchData from '../../utils/fetchData';
import { API_BASE_URL } from '../../config/config';

const ApplicationSummary = () => {
  const selectedApplicationData = useSelector(
    state => state.intakeData.selectedApplicationData
  );
  const applicationDetails = selectedApplicationData?.applicant_info;
  const selectedApplicationId = useSelector(
    state => state.intakeData.selectedAppId
  );
  const [statusList, setStatusList] = useState([]);
  useEffect(() => {
    fetchData(
      `${API_BASE_URL}/insureai/ml/intake/applications/v2/application_status?application_id=${selectedApplicationData?.application_id}`,
      'GET'
    ).then(data => {
      setStatusList(data);
    });
  }, [selectedApplicationData]);

  return (
    <div className='application-details mt-4'>
      {/* Main heading */}
      <h1 className='mb-2 text-2xl text-orange-600'>
        Application Details{' '}
        <span className='text-orange-600'>
          (<i>{selectedApplicationId}</i>)
        </span>
      </h1>
      <div className='p-6 app-content shadow-md rounded-xl'>
        <div className='flex justify-between'>
          {/* Small Heading */}
          <h2 className='font-semibold'>Summary</h2>
        </div>

        {/* Paragraph Content */}
        <p className='text-gray-700 mb-4'>
          {selectedApplicationData &&
            selectedApplicationData?.application_short_summary}
        </p>

        <p className='flex'>
          <strong>Application Id:</strong>{' '}
          {selectedApplicationData?.application_id || ''}
        </p>
        <p className='flex'>
          <strong>Priority:</strong> {selectedApplicationData?.priority}
        </p>
        <p className='flex'>
          <strong>LOBs:</strong> {selectedApplicationData?.lob || ''}
        </p>
        <p className='flex'>
          <strong>Classification:</strong>{' '}
          {selectedApplicationData?.application_classification || ''}
        </p>
        <p className='flex'>
          <strong>Details:</strong>{' '}
          {selectedApplicationData?.application_detailed_summary || ''}
        </p>
        <StatusProgressbar statusList={statusList} className='mt-6' />
      </div>
    </div>
  );
};

export default ApplicationSummary;
